import { useMediaQuery as useMUIMediaQuery, type UseMediaQueryOptions } from "@mui/material";
import {
  MEDIA_QUERY_MAX_TABLET,
  MEDIA_QUERY_MIN_DESKTOP_L,
  MEDIA_QUERY_MIN_DESKTOP_M,
  MEDIA_QUERY_MIN_DESKTOP_S,
  MEDIA_QUERY_MIN_PHONE,
  MEDIA_QUERY_MIN_TABLET,
} from "../../utils/screenSizes";

export default function useMediaQuery<Theme = unknown>(
  query: string | ((theme: Theme) => string),
  options: UseMediaQueryOptions = {
    noSsr: true,
  },
): boolean {
  return useMUIMediaQuery(query, options);
}

export const useIsMinDesktopSizeL = () => useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_L);
export const useIsMinDesktopSizeM = () => useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_M);
export const useIsMinDesktopSize = () => useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);
export const useIsMinTabletSize = () => useMediaQuery(MEDIA_QUERY_MIN_TABLET);
export const useIsMinPhoneSize = () => useMediaQuery(MEDIA_QUERY_MIN_PHONE);
export const useIsMaxTabletSize = () => useMediaQuery(MEDIA_QUERY_MAX_TABLET);
